module.exports = __webpack_public_path__ + "static/img/tipdm_js.505974e0.png";